module.exports = __webpack_public_path__ + "static/media/14.35cd1fe1.jpg";